import { Navigate, Outlet, useLocation } from "react-router-dom";

import Page from "components/Page/Page";
import ScrollToHeaderTitle from "misc/ScrollToHeaderTitle";
import { useNewBillingPage } from "v2/hooks/pilot/useNewBillingPage";

import Billing from "./Billing";
import BillingPageContent from "routes/dashboard/BillingPageContent";

import ApiCallsProvider from "providers/ApiCallsProvider";
import UserProvider from "providers/UserProvider";
import ProductFruitsProvider from "providers/ProductFruitsProvider";
import { BillingTabsRoutes } from "v2/pages/billing/tabs/BillingTabsRoutes";
import { BillingPath } from "v2/pages/billing/BillingPath";


/**
 * Component used for the feature switch only. This is the one responsible for rendering either the old
 * Billing page or the new redesigned one, based on the feature switch.
 */
export default function BillingPage() {
  const { isBillingV2Eligible } = useNewBillingPage();
  const location = useLocation();

  if (isBillingV2Eligible) {
    return <ProductFruitsProvider><Billing /></ProductFruitsProvider>;
  }

  // v1 branch: v2 tab routes (subscription/details/manage) are children of this layout
  // and would render outside BillingFlowProvider, crashing. Bounce ineligible users to /billing.
  const onV2TabPath = Object.keys(BillingTabsRoutes).some(
    tab => location.pathname.startsWith(`${BillingPath}/${tab}`)
  );
  if (onV2TabPath) {
    return <Navigate to={BillingPath} replace />;
  }

  return <>
    <ScrollToHeaderTitle />
    <UserProvider>
      <ApiCallsProvider>
        <Page title="Billing">
          <BillingPageContent />
        </Page>

        {/* for modal child-routes */}
        <Outlet />
      </ApiCallsProvider>
    </UserProvider>
  </>;
};
